console.log('--- Flow Custom Scripts ---');

Flow.set('on', 'ready', function () {
  
  //CMS control for choosing country picker style
  const country_picker_style = document.querySelector('[data-style]').dataset.style;
  
  // country picker 
  const OPTIONS_OBJECT = {
    type: country_picker_style,
    logo: true,
    containerId: 'flow-country-select',
//     currentExperience: Country,
//     countries: [Country],
//     onSelection: (country) => ({
//       country: country.iso_3166_3,
//       currency: country.currency ? country.currency : country.default_currency,
//       language: country.language,
//     }),
//  onSessionUpdate: (status, session) => {
// 	  console.log('status ===>', status);
//    console.log('session ===>', session);
//    window.location.reload();
//  },
    modalTitle: 'Select an Experience',
    isDestination: true,
    labelFormatter: (country) => {
      var currency = country.currency ? country.currency : country.default_currency;
      return country.name + ' (' + currency + ')';
    }
  }
  
  flow.countryPicker.createCountryPicker(OPTIONS_OBJECT);
  
  // retrieve features and display custom content based on boolean/text
  Flow.features.getFeatures({ 
    success: (data) => { 
      console.log(data);
      data.values.forEach(function(value) {
        if(value.feature.key == "text") {
          if(Flow.getExperience()) {
            const promoText = document.querySelector('[flow-text]');
            promoText.innerText = value.value;
          }
        } else if(value.value && value.feature.key == 'banner') {
          const heroBanner = document.querySelector('.template-index #shopify-section-hero .hero');
          const heroTitle = document.querySelector('#shopify-section-hero .mega-title');
          const heroSubtitle = document.querySelector('#shopify-section-hero .mega-subtitle');
          
          if(heroBanner) {
            heroBanner.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0030/9585/5204/files/flow-grey.png?59475510870016964')`;
            heroBanner.style.backgroundPosition = 'center center';
            heroTitle.innerText = 'This is your Domestic Shop';
            heroSubtitle.innerText = 'You need Flow!'
          }
        }
      });
    }, 
    error: (err) => console.log(err) 
  });
  
  
  // All functions within should only execute if an experience is set
  if (Flow.getExperience()) {
    
    //Welcome Mat
    const modal = document.getElementById('myModal');
    const modalContent = document.querySelector('.model-content');
    const countrySelect = document.getElementById('welcome-mat-country');
    const currencySelect = document.getElementById('welcome-mat-currency');
    const saveButton = document.getElementById('welcome-mat-save');
    const cancelButton = document.getElementById('welcome-mat-cancel');
    const closeButton = document.getElementsByClassName("close")[0];
    const resetButton = document.getElementById('welcome-mat-reset');
    
    //set countries and currency to dropdown elements
    if(modal) {
      Flow.getCountries({
        success: (data) => {
          let duplicatesExcluded = [];
          data.forEach((country) => {
            let optionCountry = document.createElement('option');
            optionCountry.value = country.iso_3166_3;
            optionCountry.innerText = country.name;
            countrySelect.append(optionCountry);

            let optionCurrency = document.createElement('option');
            optionCurrency.value = country.default_currency;
            optionCurrency.innerText = country.default_currency;
            
            if(duplicatesExcluded.indexOf(country.default_currency) < 0) {
             duplicatesExcluded.push(country.default_currency);
             currencySelect.append(optionCurrency);
            }

          })
          countrySelect.value = Flow.session.getCountry();
          currencySelect.value = Flow.session.getCurrency();
        }
      });
      
      let hasBeenClicked = localStorage.getItem('welcome-saved');

      //display the modal only if they haven't saved yet
      if(hasBeenClicked != "true") {
      	modal.style.display = "block";
      }
      
      // When the user clicks on x or cancel, close the modal
      closeButton.onclick = function() {
        modal.style.display = "none";
      }
      
      cancelButton.onclick = function() {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
      
      saveButton.onclick = function() {
        Flow.updateSession({
          country: countrySelect.value,
          currency: currencySelect.value
        }, { 
          success: function() { 
          	localStorage.setItem('welcome-saved', 'true'); 
          	location.reload(); 
        }, error: (err) => console.error(err) });
      }
      
      resetButton.onclick = function() {
      	localStorage.setItem('welcome-saved', 'false');
        location.reload();
      }
    }
    
    console.log(Flow.cache.localizedVariants.store);
    //get all variants of the product into an array
    const selectorOptions = Array.from(document.querySelectorAll('[name="id"] option'));
    const idArray = selectorOptions.map((option) => option.value);

    const variantOptions = {
      variants: idArray, // List of variant ids to load
      experience: Flow.getExperience(), // Limits results by Flow experience key
      success: (status, variants) => {
        console.log("👇🏻 Variants in Flow Cache 👇🏻");
        console.log(variants)
      },
      error: (status, error) => console.log(status, error), // Error callback
    };

    //load variants into cache
    if(selectorOptions.length > 0) {
        Flow.variants.load(variantOptions);
    }
    
    //console logging the localStorage session info
    console.log("👇🏻 Flow Session 👇🏻");
    console.log(JSON.parse(window.localStorage.getItem('_f60_session')));
    
    Flow.set('on', 'pageview.checkout_thank_you', function() {
      $.ajax({
        url: "/cart/clear.js",
        method: "POST"
      })
      .success((data) => console.log('success', data))
      .error((data) => console.error(data));
    });
    
    
  }
});


